const _ = new WeakMap();

/**
 * @constructor
 * @param {function(): Promise} on
 * @param {function(*): Promise} off
 */
export default function Mode(on, off = (output => output instanceof Function ? output.call() : null)) {
    _.set(this, {
        on: on,
        off: off,
        pending: null,
    });
}

Mode.prototype.on = function () {
    const o = _.get(this);
    return o.pending = Promise.resolve(o.pending).then(o.on);
}

Mode.prototype.off = function () {
    const o = _.get(this);
    return o.pending = Promise.resolve(o.pending).then(o.off);
}

